module.exports = __webpack_public_path__ + "img/JAOC_POP_PestoSauce_round.c27d8c10.png";